import Form from "./form";

export default class SiteVisitForm extends Form {
    constructor($el) {
        super($el);

        this.$addDateTimeslot = $el.querySelector('[data-add-date-timeslot]');
        this.$toggleDateTimeslot = this.$addDateTimeslot.querySelector('[data-date-timeslot-toggle]');

        this.$date2 = $el.querySelector('[data-date-2]');
        this.$timeslot2 = $el.querySelector('[data-timeslot-2]');
        this.dateAndTimeSlot2Visible = false;
        this.$date3 = $el.querySelector('[data-date-3]');
        this.$timeslot3 = $el.querySelector('[data-timeslot-3]');
        this.dateAndTimeSlot3Visible = false;

        this.$date2.style.display = 'none';
        this.$timeslot2.style.display = 'none';
        this.$date3.style.display = 'none';
        this.$timeslot3.style.display = 'none';

        this.toggleNewDateFields = this.toggleNewDateFields.bind(this);

        this.$toggleDateTimeslot.addEventListener('click', this.toggleNewDateFields);
    }

    toggleNewDateFields(e) {
        e.preventDefault();

        // if dateAndTimeSlot2Visible is false, show second set of inputs
        if ( ! this.dateAndTimeSlot2Visible) {
            this.$date2.style.display = 'table-row';
            this.$timeslot2.style.display = 'table-row';
            this.dateAndTimeSlot2Visible = true;
        }

        // if dateAndTimeSlot2Visible is true and dateAndTimeSlot3Visible still false, show third set of inputs
        else if (this.dateAndTimeSlot2Visible && ! this.dateAndTimeSlot3Visible) {
            this.$date3.style.display = 'table-row';
            this.$timeslot3.style.display = 'table-row';
            this.dateAndTimeSlot3Visible = true;

            this.$addDateTimeslot.style.display = 'none';
        }
    }
}